/**
 * @desc: 对账数据
 * @author: huli
 * @version: v1.0
 */

import * as Models from '@/api/T6/reconciliationData'

export default {
  namespaced: true,
  actions: {
    getTradeListData(ctx, payload) {
      return Models.getTradeListData(payload).then(res => {
        return (res && res.status === 200 && res.data) || [{}, {}]
      })
    },

    getAccountListData(ctx, payload) {
      return Models.getAccountListData(payload).then(res => {
        return (res && res.status === 200 && res.data) || [{}, {}]
      })
    },

    getCreditListData(ctx, payload) {
      return Models.getCreditListData(payload).then(res => {
        return (res && res.status === 200 && res.data) || [{}, {}]
      })
    },

  }
}
